import { createStore } from 'owa-satcheljs';
import type MailOrganizationViewTypes from './schema/MailOrganizationViewTypes';
import type ViewType from './schema/ViewType';

const defaultExport: () => MailOrganizationViewTypes = createStore<MailOrganizationViewTypes>(
    'mailOrganizationSettingsStore',
    {
        messageListExpansionType: 3,
        readingPaneViewType: 3,
    }
);
export default defaultExport;
